// ── OSCAL Document Lifecycle (REQ-5.1) ────────────────────
export type LifecycleStatus =
  | "draft"
  | "in_review"
  | "approved"
  | "published"
  | "superseded"
  | "withdrawn";

export const LIFECYCLE_STAGES: {
  key: LifecycleStatus;
  label: string;
}[] = [
  { key: "draft", label: "Draft" },
  { key: "in_review", label: "In Review" },
  { key: "approved", label: "Approved" },
  { key: "published", label: "Published" },
];

export const lifecycleColor: Record<LifecycleStatus, string> = {
  draft: "bg-slate-100 dark:bg-white/[0.07] text-slate-600 dark:text-white/50",
  in_review:
    "bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-400",
  approved:
    "bg-indigo-100 dark:bg-indigo-500/20 text-indigo-700 dark:text-indigo-400",
  published:
    "bg-emerald-100 dark:bg-emerald-500/20 text-emerald-700 dark:text-emerald-400",
  superseded:
    "bg-slate-100 dark:bg-white/[0.07] text-slate-600 dark:text-white/50",
  withdrawn:
    "bg-slate-100 dark:bg-white/[0.07] text-slate-600 dark:text-white/50",
};
